import type NumberUnit from '@exodus/currency';
import { useSelector } from 'react-redux';

import byAssetUsdSelector from '@/ui/flux/fiat-balances/selectors/by-asset-usd';
import selectors from '@/ui/flux/selectors';

function useUsdBalanceByAsset(): Record<string, NumberUnit> | undefined {
  const byAsset = useSelector(byAssetUsdSelector);
  const ratesLoaded = useSelector(selectors.rates.loaded);
  const fiatBalancesLoaded = useSelector<unknown, boolean>(
    selectors.fiatBalances.loaded,
  );

  const loaded = fiatBalancesLoaded && ratesLoaded;
  return loaded ? byAsset : undefined;
}

export default useUsdBalanceByAsset;
